import { useState } from "react";

const faqs = [
  {
    question: "Est-ce juste un réglage ou faut-il changer une pièce ?",
    answer: "Dans environ 50% des cas, un réglage des gonds, des points de compression et des galets de fermeture suffit à restaurer une fermeture parfaite. Si la crémone est usée, les joints sont déformés, ou un gond est trop écrasé, nous remplaçons la pièce sur place. Notre technicien diagnostique chaque élément et vous explique exactement ce qui est nécessaire avant de commencer. Pas de remplacement inutile.",
  },
  {
    question: "Faut-il changer les joints d'une fenêtre qui laisse passer l'air ?",
    answer: "Les joints en caoutchouc ou EPDM ont une durée de vie d'environ 15 à 20 ans. S'ils sont durcis, fendus ou décollés, ils doivent être remplacés. Nous posons des joints neufs de même profil, adaptés à la marque de votre fenêtre. Le remplacement des joints combiné à un réglage des points de compression redonne à votre fenêtre son étanchéité d'origine. C'est une intervention rapide qui change radicalement le confort de votre pièce.",
  },
  {
    question: "Quel est le délai pour réparer une fenêtre qui ferme mal ?",
    answer: "Un réglage standard prend 30 minutes à 1 heure. Si le remplacement d'une crémone, d'un gond ou de joints est nécessaire, comptez 1h à 2h. Nous intervenons du lundi au samedi, matin et après-midi. Pour une situation d'urgence — fenêtre qui ne ferme plus du tout, risque d'intrusion ou d'infiltration — nous pouvons généralement intervenir sous 24h dans tout le Bas-Rhin, incluant Strasbourg, Schiltigheim, Haguenau et Illkirch.",
  },
  {
    question: "Le prix de la réparation est-il inclus dans le devis gratuit ?",
    answer: "Oui, le diagnostic et le devis sont entièrement gratuits, et le déplacement dans tout le Bas-Rhin est aussi offert. Le prix de la réparation dépend de la pièce concernée : réglage simple, remplacement de joints, crémone, ou gond. Chaque élément est détaillé dans le devis. La pièce neuve et la main-d'œuvre sont comprises. Pas de surprise : vous savez exactement ce que vous payez avant que nous commencions.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Questions fréquentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            FAQ — <span className="font-serif italic">Fenêtre qui ferme mal</span>
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-rose-200 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className="font-semibold text-plum text-sm md:text-base pr-4">
                    {faq.question}
                  </span>
                  <div
                    className={`w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0 transition-transform ${
                      openIndex === i ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-plum" />
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-plum-dark text-sm md:text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}